import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HeaderComponent from "../../components/HeaderComponent";
import WelcomeComponent from "../../components/WelcomeComponent";
import { useState } from "react";
import LoginComponent from "../../components/Demo/Auth/LoginComponent";
import FpComponent from "../../components/Demo/Auth/FpComponent";
import { useAuthCheck } from "../../hooks/Demo/sharedLogic";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";

const Welcome = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [fp, setFp] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  useAuthCheck();

  if (loginLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)",
        }}
      >
        <CircularProgress 
          size={48}
          thickness={4}
          sx={{ 
            color: "#FF592C",
            marginBottom: 2,
          }} 
        />
        <Typography 
          sx={{ 
            color: "#64748b", 
            fontSize: "1.05rem", 
            fontWeight: 600,
            fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
            letterSpacing: "-0.01em",
          }}
        >
          Loading your workspace...
        </Typography>
      </Box>
    );
  }

  return (
    <div className="welcome-page-container">
      {open && (
        <LoginComponent
          open={open}
          setOpen={setOpen}
          setFp={setFp}
          setLoading={setLoginLoading}
        />
      )}
      {fp && <FpComponent fp={fp} setFp={setFp} setOpen={setOpen} />}
      <HeaderComponent pageName={"welcome"} />
      <Box sx={{ marginBottom: 4 }} />
      <WelcomeComponent />

      <Box className="welcome-text">
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "2.25rem", sm: "2.75rem", md: "3.5rem" },
            fontWeight: 800,
            color: "#1a1a1a",
            marginBottom: 1.5,
            textAlign: "center",
            letterSpacing: "-0.04em",
            position: "relative",
            fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
            lineHeight: 1.1,
          }}
        >
          {t("welcomeView.welcome")}
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "1rem", sm: "1.1rem" },
            color: "#64748b",
            marginBottom: 4.5,
            textAlign: "center",
            fontWeight: 500,
            letterSpacing: "-0.01em",
            fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
            lineHeight: 1.6,
          }}
        >
          Sign in to continue to your account
        </Typography>

        {/* Sign In Button */}
        <Button
          variant="contained"
          className="welcome-login-btn"
          fullWidth
          startIcon={<LoginIcon />}
          sx={{
            borderRadius: 2,
            backgroundColor: "#FF592C",
            padding: "16px 48px",
            fontSize: "1.1rem",
            fontWeight: 700,
            textTransform: "none",
            boxShadow: "0 4px 14px 0 rgba(255, 89, 44, 0.3)",
            maxWidth: "400px",
            position: "relative",
            overflow: "hidden",
            fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
            letterSpacing: "-0.01em",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: "-100%",
              width: "100%",
              height: "100%",
              background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
              transition: "left 0.5s",
            },
            "&:hover": {
              backgroundColor: "#e64a1f",
              boxShadow: "0 6px 20px 0 rgba(255, 89, 44, 0.4)",
              transform: "translateY(-2px)",
              "&::before": {
                left: "100%",
              },
            },
            "&:active": {
              transform: "translateY(0)",
            },
          }}
          onClick={() => setOpen(true)}
        >
          {t("welcomeView.login")}
        </Button>

        <Box
          sx={{
            marginTop: 3.5,
            padding: "14px 24px",
            backgroundColor: "rgba(255, 89, 44, 0.05)",
            borderRadius: 2,
            border: "1px solid rgba(255, 89, 44, 0.1)",
            maxWidth: "400px",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: "0.9rem",
              color: "#64748b",
              textAlign: "center",
              lineHeight: 1.6,
              fontWeight: 500,
              fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
              letterSpacing: "-0.005em",
            }}
          >
            🔒 Your data is secured with enterprise-grade encryption
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default Welcome;
